import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin, adminRegister, forgotPassword } from '../api';

export default function AcessoProfissionalScreen() {
  const navigate = useNavigate();
  
  const [token, setToken] = useState<string | null>(sessionStorage.getItem('authToken'));
  const [isLoginTab, setIsLoginTab] = useState(true);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [forgotEmail, setForgotEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    setToken(null);
  };

  const handleForgotPassword = async () => {
    setError('');
    setSuccessMsg('');
    if (!forgotEmail) {
      setError('Digite seu e-mail');
      return;
    }
    setLoading(true);
    try {
      const res = await forgotPassword(forgotEmail);
      if (res?.success) {
        setSuccessMsg(res.message || 'Nova senha enviada para o seu e-mail!');
        setForgotEmail('');
        // Volta para tela de login após 3 segundos
        setTimeout(() => {
          setShowForgotPassword(false);
          setSuccessMsg('');
        }, 3000);
      }
    } catch (e: any) {
      setError(e?.response?.data?.error || 'Erro ao recuperar senha');
    } finally {
      setLoading(false);
    }
  };
  
  const handleSubmit = async () => {
    setError('');
    setSuccessMsg('');
    if (!username || !password) {
      setError('Preencha os campos obrigatórios');
      return;
    }
    setLoading(true);
    try {
      if (isLoginTab) {
        const res = await adminLogin(username, password);
        if (res?.token) {
          setToken(res.token);
        } else {
          setError('Login falhou');
        }
      } else {
        const res = await adminRegister(username, password);
        if (res?.success) {
          setSuccessMsg('Conta criada! Faça login para continuar.');
          setIsLoginTab(true);
          setPassword('');
        }
      }
    } catch (e: any) {
      setError(e?.response?.data?.error || 'Ocorreu um erro');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    // Tela de recuperação de senha
    if (showForgotPassword) {
      return (
        <div style={{ maxWidth: 420, margin: '0 auto', paddingTop: 64 }}>
          <div style={{ textAlign: 'center', marginBottom: 18 }}>
            <img src="/assets/icones-curriculo-05.svg" alt="Ícone Acesso Profissional" style={{ width: '64px', height: '64px' }} />
          </div>
          <h2 style={{ color: 'var(--primary-color)', fontWeight: 700, fontSize: 24, textAlign: 'center', marginBottom: '8px' }}>
            Recuperar Senha
          </h2>
          <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: 14, marginBottom: 24 }}>
            Digite seu e-mail cadastrado e enviaremos uma nova senha.
          </p>

          {successMsg && <div style={{ color: 'green', marginBottom: 16, fontSize: 14, textAlign: 'center', padding: '12px', backgroundColor: '#e8f5e9', borderRadius: '8px' }}>{successMsg}</div>}

          <div className="form-group" style={{ marginBottom: 16 }}>
            <label>E-mail</label>
            <input 
              type="email" 
              value={forgotEmail} 
              onChange={e => setForgotEmail(e.target.value)} 
              placeholder="seu@email.com"
              onKeyDown={(e) => e.key === 'Enter' && handleForgotPassword()} 
            />
          </div>
          
          {error && <div style={{ color: 'red', marginTop: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}
          
          <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
            <button className="btn btn-primary" onClick={handleForgotPassword} disabled={loading} style={{ flex: 1, padding: '12px' }}>
              {loading ? 'Enviando...' : 'Enviar Nova Senha'}
            </button>
            <button className="btn btn-outline" onClick={() => { setShowForgotPassword(false); setError(''); setSuccessMsg(''); }} style={{ padding: '12px' }}>
              Voltar
            </button>
          </div>
        </div>
      );
    }

    // Tela de login/cadastro
    return (
      <div style={{ maxWidth: 420, margin: '0 auto', paddingTop: 64 }}>
        <div style={{ textAlign: 'center', marginBottom: 18 }}>
          <img src="/assets/icones-curriculo-05.svg" alt="Ícone Acesso Profissional" style={{ width: '64px', height: '64px' }} />
        </div>
        <h2 style={{ color: 'var(--primary-color)', fontWeight: 700, fontSize: 24, textAlign: 'center', marginBottom: '8px' }}>
          Acesso Profissional
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: 14, marginBottom: 24, lineHeight: 1.5 }}>
          Salve seus currículos na sua conta para acessar quando quiser. Edite, atualize e gere PDFs a qualquer momento.
        </p>
        
        <div style={{ display: 'flex', borderBottom: '2px solid var(--border-color)', marginBottom: '24px' }}>
          <button 
            style={{ flex: 1, padding: '12px', background: 'none', border: 'none', borderBottom: isLoginTab ? '2px solid var(--primary-color)' : 'none', fontWeight: isLoginTab ? 700 : 500, color: isLoginTab ? 'var(--primary-color)' : 'var(--text-light)', cursor: 'pointer', marginBottom: '-2px' }}
            onClick={() => { setIsLoginTab(true); setError(''); setSuccessMsg(''); }}
          >
            Entrar
          </button>
          <button 
            style={{ flex: 1, padding: '12px', background: 'none', border: 'none', borderBottom: !isLoginTab ? '2px solid var(--primary-color)' : 'none', fontWeight: !isLoginTab ? 700 : 500, color: !isLoginTab ? 'var(--primary-color)' : 'var(--text-light)', cursor: 'pointer', marginBottom: '-2px' }}
            onClick={() => { setIsLoginTab(false); setError(''); setSuccessMsg(''); }}
          >
            Cadastrar
          </button>
        </div>

        {successMsg && <div style={{ color: 'green', marginBottom: 16, fontSize: 14 }}>{successMsg}</div>}

        <div className="form-group" style={{ marginBottom: 16 }}>
          <label>E-mail</label>
          <input type="email" value={username} onChange={e => setUsername(e.target.value)} placeholder="seu@email.com" />
        </div>
        <div className="form-group" style={{ marginBottom: 16 }}>
          <label>Senha</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && handleSubmit()} />
        </div>
        
        {error && <div style={{ color: 'red', marginTop: 8, marginBottom: 16, fontSize: 14 }}>{error}</div>}
        
        {isLoginTab && (
          <div style={{ textAlign: 'right', marginBottom: 8 }}>
            <button 
              onClick={() => { setShowForgotPassword(true); setError(''); setSuccessMsg(''); setForgotEmail(username); }}
              style={{ background: 'none', border: 'none', color: 'var(--primary-color)', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}
            >
              Esqueci minha senha
            </button>
          </div>
        )}
        
        <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading} style={{ flex: 1, padding: '12px' }}>
            {loading ? 'Aguarde...' : (isLoginTab ? 'Entrar no Painel' : 'Criar Conta')}
          </button>
          <button className="btn btn-outline" onClick={() => navigate('/')} style={{ padding: '12px' }}>
            Voltar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 420, margin: '0 auto', paddingTop: 32 }}>
      <div style={{ textAlign: 'center', marginBottom: 18 }}>
        <img src="/assets/icones-curriculo-05.svg" alt="Ícone Acesso Profissional" style={{ width: '48px', height: '48px' }} />
      </div>
      <h2 style={{ color: 'var(--primary-color)', fontWeight: 700, fontSize: 22, marginBottom: 8, textAlign: 'center' }}>Painel Profissional</h2>
      <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: 14, marginBottom: 24 }}>
        Bem-vindo! Escolha uma opção abaixo.
      </p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <button className="btn btn-primary" style={{ fontSize: 16, padding: '12px 24px', fontWeight: 600 }} onClick={() => navigate('/admin')}>
          <img src="/assets/icones-curriculo-04.svg" alt="Ícone Banco" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
          Banco de dados (Ver currículos)
        </button>
        <button className="btn btn-secondary" style={{ fontSize: 15, padding: '12px 24px', fontWeight: 600 }} onClick={() => navigate('/cpf')}>
          <img src="/assets/icones-curriculo-01.svg" alt="Ícone Adicionar" style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} />
          Adicionar Novo Currículo no BD
        </button>
        <button 
          className="btn btn-outline" 
          style={{ fontSize: 15, padding: '12px 24px', fontWeight: 600 }} 
          onClick={() => navigate('/configuracoes')}
        >
          <img src="/assets/icones-curriculo-06.svg" alt="Ícone Config" style={{ width: '20px', height: '20px', opacity: 0.7 }} />
          Configurações
        </button>
      </div>

      <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center', gap: '16px' }}>
        <button className="btn btn-outline" style={{ fontSize: 14, padding: '8px 20px' }} onClick={handleLogout}> 
          Sair da Conta
        </button>
        <button className="btn btn-outline" style={{ fontSize: 14, padding: '8px 20px' }} onClick={() => navigate('/')}> 
          Início
        </button>
      </div>
    </div>
  );
}
